import { Button } from '@/shared/Button';
import { useContext } from 'react';
import { ExportContext } from '../ExportCompound.context';

export const DownloadGraphics = (): React.ReactNode => {
  const { handleDownloadGraphics, data } = useContext(ExportContext);

  return (
    <div className={`mt-6 ${data.graphicsMapToggle ? 'hidden' : 'visible'}`}>
      <Button onClick={handleDownloadGraphics}>Download image</Button>
    </div>
  );
};
